module.exports = __webpack_public_path__ + "img/icon-history.86436d4b.svg";